<template>
    <!--== Volunteers Table ==-->
    <article>
        <div class="d-flex justify-content-between m-5 align-items-center table-title">
            <div class="me-auto">
                <h1 class="">VOLUNTEERS</h1>
            </div>
            <div class="d-grid gap-2 d-md-block">
                <router-link :to="`/approved-volunteers`" custom v-slot="{ navigate }">
                    <button class="btn btn-primary btn-lg ms-2 fw-semibold text-white" style="--bs-btn-padding-x: 0.9rem;"
                        @click="navigate">
                        Approved
                    </button>
                </router-link>
                <router-link :to="`/declined-volunteers`" custom v-slot="{ navigate }">
                    <button class="btn btn-danger btn-lg ms-2 fw-semibold text-white" style="--bs-btn-padding-x: 1.1rem"
                        @click="navigate">
                        Declined
                    </button>
                </router-link>
            </div>
        </div>
        <div class="table-responsive m-5 table-container" id="no-more-tables">
            <table class="table table-hover text-center" style="position: relative;">
                <!-- Loading overlay -->
                <v-overlay v-model="loading" contained class="align-center justify-center" scrim="transparent" persistent>
                    <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <thead class="table-blue text-light text-uppercase">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">E-mail</th>
                        <th scope="col">Contact Number</th>
                        <th scope="col">Category</th>
                        <th scope="col">Credentials</th>
                        <th scope="col">Archive</th>
                    </tr>
                </thead>
                <!-- Show data only if volunteers is not empty -->
                <tbody v-if="volunteers.length != 0">
                    <tr v-for="volunteer in volunteers" :key="volunteer.id">
                        <td data-title="Name" class="align-middle">{{ volunteer.Name }}</td>
                        <td data-title="Email" class="align-middle">{{ volunteer.Email }}</td>
                        <td data-title="Contact Number" class="align-middle">{{ volunteer.ContactNumber }}</td>
                        <td data-title="Category" class="align-middle">{{ volunteer.EventAppliedId }}</td>
                        <td data-title="Credentials">
                            <router-link :to="`/volunteers/view-cvid/${volunteer.id}`">
                                <button class="btn btn-link" title="View CV/ID">
                                    <font-awesome-icon icon="fa-solid fa-id-card" />
                                </button>
                            </router-link>
                        </td>
                        <td data-title="Archive">
                            <button class="btn btn-link" title="Archive Record"><font-awesome-icon
                                    icon="fa-solid fa-folder-open" @click="archiveVolunteer(volunteer.id)" /></button>
                        </td>
                    </tr>
                </tbody>
                <!-- Indicate that the volunteers table is empty otherwise -->
                <tbody v-else>
                    <tr>
                        <td colspan="6" class="text-center"> {{ loading ? "Loading..." : "No Volunteers" }} </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { db } from "@/firebase";
import { collection, getDoc, doc, query, where, orderBy, onSnapshot, updateDoc } from "firebase/firestore";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    setup() {
        const volunteers = ref([])
        let unsubscribe;

        // Overlay handling
        const loading = ref(false);

        // Check if the event applied still exists
        const ifEventExists = async (value) => {
            const docSnap = await getDoc(doc(db, "Events", value));

            if (docSnap.exists()) {
                return docSnap.data()
            } else {
                return false
            }
        }

        onMounted(() => {

            // Show loading overlay
            loading.value = true;

            // Get all volunteers that are not archived and is accepted (ordered by oldest to newest)
            const volunteersCollection = collection(db, "Volunteer Applications");
            const q = query(volunteersCollection, where("IsAccepted", "==", null), where("IsArchived", "==", false), orderBy("CreationTimestamp", "asc"));
            unsubscribe = onSnapshot(q, (snapshot) => {
                volunteers.value = snapshot.docs.map((doc) => {
                    const data = doc.data();
                    for (const [key] of Object.entries(data)) {
                        // Replace EventAppliedId with loading text
                        if (key == 'EventAppliedId') {
                            data[key] = "Loading..."
                        }
                    }
                    return { id: doc.id, ...data }
                })

                snapshot.docs.forEach((doc, index) => {
                    const data = doc.data();
                    for (const [key, value] of Object.entries(data)) {
                        if (key == 'EventAppliedId') {
                            ifEventExists(value).then((result) => {
                                if (result) {
                                    // Replace EventAppliedId with the event name
                                    volunteers.value[index][key] = result.Category
                                } else {
                                    // Indicate that there are no events with the id
                                    volunteers.value[index][key] = "Event Applied Deleted"
                                }
                            })
                                .catch((error) => {
                                    console.log(error)
                                })
                        }
                    }
                })

                // Hide loading overlay once completed
                loading.value = false;
            })
        })

        onUnmounted(() => {
            unsubscribe();
        })

        const archiveVolunteer = async (Id) => {
            await updateDoc(doc(db, "Volunteer Applications", Id), {
                IsArchived: true
            });
            toast.success("Volunteer successfully archived", {
                autoClose: 2000,
            });
        }
        return { volunteers, loading, archiveVolunteer }

    }
}
</script>

<style scoped src="@/assets/css/admin.css"></style>